import type { AuditEntryPayload } from '@Application/AuditTrail/Actions/auditEntriesFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `actorUserId`, `resourceId`, `facilityId` and `beneficiaryId` are bare integers, never `{ id }`:
 * the server carries no foreign key to those entities, so an entry survives their deletion.
 * `resourceType` is `null` on every authentication entry — that is the normal case, not an error.
 */
class AuditEntryView {
	readonly id: number;
	readonly occurredAt: string;
	readonly action: { readonly value: string; readonly label: string };
	readonly outcome: { readonly value: string; readonly label: string };
	readonly actorUserId: number | null;
	readonly resourceType: { readonly value: string; readonly label: string } | null;
	readonly resourceId: number | null;
	readonly facilityId: number | null;
	readonly beneficiaryId: number | null;
	readonly ipAddress: string | null;
	readonly context: string | null;

	constructor(payload: AuditEntryPayload) {
		this.id = payload.id;
		this.occurredAt = payload.createdAt;
		this.action = payload.action;
		this.outcome = payload.outcome;
		this.actorUserId = payload.actorUserId;
		this.resourceType = payload.resourceType;
		this.resourceId = payload.resourceId;
		this.facilityId = payload.facilityId;
		this.beneficiaryId = payload.beneficiaryId;
		this.ipAddress = payload.ipAddress;
		this.context = payload.context;

		Object.freeze(this);
	}
}

export default AuditEntryView;
